import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

export const LanguagePopup = ({ open, onLanguageSelect, translations }) => {
  return (
    <Dialog open={open}>
      <DialogContent className="sm:max-w-md bg-brand-lightPink border-2 border-brand-pink/20">
        <DialogHeader>
          <div className="flex justify-center mb-4">
            <div className="p-4 bg-brand-navy rounded-full">
              <Globe className="h-8 w-8 text-white" />
            </div>
          </div>
          <DialogTitle className="text-2xl text-center font-serif text-brand-navy">
            {translations.en.languageTitle}
          </DialogTitle>
          <DialogDescription className="text-center text-gray-600 font-medium">
            {translations.en.languageSubtitle}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 mt-6">
          <Button
            onClick={() => onLanguageSelect('hi')}
            className="h-14 text-lg bg-brand-pink hover:bg-brand-pink/90 text-white font-semibold shadow-lg transform transition-all duration-200 hover:scale-105"
          >
            हिंदी
          </Button>
          <Button
            onClick={() => onLanguageSelect('en')}
            className="h-14 text-lg bg-brand-navy hover:bg-brand-navy/90 text-white font-semibold shadow-lg transform transition-all duration-200 hover:scale-105"
          >
            English
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
